import React from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import AppContext from './contexts/AppContext'
import history from 'history.js'
import routes from './RootRoutes'
import { GlobalCss, MatxSuspense, MatxTheme, MatxLayout } from 'app/components'
import sessionRoutes from './views/sessions/SessionRoutes'
import AuthGuard from './auth/AuthGuard'
import { AuthProvider } from 'app/contexts/CognitoAuthContext'
import { SettingsProvider } from 'app/contexts/SettingsContext'
import { hot } from 'react-hot-loader/root'
import { Provider as MobxProvider } from 'mobx-react'
import { createStore } from './store'
import { ToastContainer } from 'react-toastify'
import { Chart } from 'chart.js'
import zoomPlugin from 'chartjs-plugin-zoom'
import 'react-toastify/dist/ReactToastify.css'
import './styles.css'
import { ReportIssueProvider } from './contexts/ReportIssueContext'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { EventBusProvider } from './contexts/EventsBusContext'

Chart.register(zoomPlugin)

const store = createStore()

const App = () => {
  return (
    <AppContext.Provider value={{ routes }}>
      <EventBusProvider>
        <Router history={history}>
          <MobxProvider {...store}>
            <SettingsProvider>
              <ReportIssueProvider>
                <DndProvider backend={HTML5Backend}>
                  <MatxTheme>
                    <GlobalCss />
                    <AuthProvider>
                      <MatxSuspense>
                        <ToastContainer />
                        <Switch>
                          {/* AUTHENTICATION PAGES (SIGNIN, SIGNUP ETC.) */}
                          {sessionRoutes.map((item, i) => (
                            <Route
                              key={i}
                              path={item.path}
                              component={item.component}
                            />
                          ))}
                          {/* AUTH PROTECTED DASHBOARD PAGES */}
                          <AuthGuard>
                            <MatxLayout /> {/* RETURNS <Layout1/> component */}
                          </AuthGuard>
                        </Switch>
                      </MatxSuspense>
                    </AuthProvider>
                  </MatxTheme>
                </DndProvider>
              </ReportIssueProvider>
            </SettingsProvider>
          </MobxProvider>
        </Router>
      </EventBusProvider>
    </AppContext.Provider>
  )
}

export default process.env.NODE_ENV === 'development' ? hot(App) : App
